import { checkIfAnchorTag, linkify } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { LinkPreview } from '../linkPreview/linkPreview.module';
import './textMessage.scss';

export const TextMessageTemplate = (model) => {
	const { sender, message, message_id, style = '' } = model || {};
	const msg = (() => {
		if (typeof message === 'string') return message;
		if (message?.isPassword) return '*'.repeat(message.text?.length || 0);
		return message?.text || '';
	})();
	const linkifyString = linkify(msg);
	const isIframe = !!(
		message?.data?.answer_type === 'IFRAME' &&
		!ENGT_CHAT.get('config.isOldMessage') &&
		ENGT_CHAT.get('config.enableFaqIframes')
	);

	const isAnchorTag = checkIfAnchorTag(linkifyString);

	const getLinkPreview = () => {
		const linkPreview = new LinkPreview({
			msg: linkifyString,
			message_id,
			is_iframe: isIframe,
		});
		return linkPreview.render();
	};

	const renderQuoteMessage = () => {
		if (model.linked_event_id) {
			/* html */
			return `
				<div class="engt-msg engt-msg-${sender} engt-quote-msg-${sender} engt-msg-border-${sender} engt-quote-msg"
					id="quote-${model.message_id}" style="${style}">
					<div onclick="ENGT_CHAT.scrollIntoView('${model.linked_event_id}')" 
						class="engt-quoted-text engt-msg-${sender} engt-msg-quote engt-msg-quote-${sender}" >
						${model.linked_response_data}
					</div>
					<div class="engt-linked-text">${renderText()}</div>
				</div>
			`;
		}
		/* html */
		return `
				<div class="engt-msg engt-msg-${sender} engt-msg-border-${sender}" id="engt-msg-${model.message_id}" style="${style}">
			         ${renderText()}
			    </div>
			`;
	};

	const renderText = () =>
		/* html */
		`<span class="engt-msg-text">${isAnchorTag ? getLinkPreview() : msg}</span>`;

	const renderMessage = () => renderQuoteMessage();
	/* html */

	const html = message ? renderMessage() : '';

	return html;
};
